export default {
    root: {
        backgroundColor: '#d3d3d3',
    }
  };
  